module.exports = __webpack_public_path__ + "static/media/life-loader-sky-blue.8977080f.gif";